import { useMemo } from "react";
import { useSharedState } from "hooks";
import { queryService } from "services";

const useQuery = () => {
  const [query] = useSharedState(queryService.query$);
  const resultset = useMemo(
    () => (query && query.report && query.report.resultset) || [],
    [query]
  );
  const actions = useMemo(
    () => ({
      create: queryService.create,
      current: queryService.current,
      edit: queryService.edit,
      delete: queryService.delete,
      topic: queryService.topic,
      note: queryService.note,
      response: queryService.response,
      file: queryService.file,
      download: queryService.download,
    }),
    []
  );
  return { query, resultset, actions };
};

export { useQuery };
